export default "__VITE_ASSET__D4xcqUDf__"